import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";
import { MobileIcon, WebIcon } from "../../icons";

interface Step2SDKProps {
  sdkType: string;
  onUpdateState: (value: string) => void;
}

const Step2SDK: React.FC<Step2SDKProps> = ({ sdkType, onUpdateState }) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">Configure new Platform</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                {
                  label: "Mobile App",
                  value: "mobile-app",
                  icon: <MobileIcon />,
                },
                { label: "Web", value: "web", icon: <WebIcon /> },
              ]}
              value={sdkType}
              onChange={onUpdateState}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step2SDK;
